import Grud from './grud.service';

class DistributionPointService extends Grud {
    constructor() {
      super('distributionpoint');
    }
  
}
export default DistributionPointService;